import ServiceCollection from "src/services/ServiceCollection";
import {Box} from "@amzn/awsui-components-react";
import React from "react";

export default function LinkedJEWorksheetView(props: { services: ServiceCollection }) {
    return (
        // TODO: Add linked JE worksheet components
        <Box padding={{top: "xxl"}}>
        </Box>
    );
}
